export default __webpack_public_path__ + "static/media/e7a02fd0f04fd1f0a41a5942c5df1d81.svg";